module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('em', [_vm._v("What He Thought")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('em', [_vm._v("for Fabbio Doplicher")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We were supposed to do a job in Italy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and, full of our feeling for")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ourselves (our sense of being")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Poets from America) we went")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("from Rome to Fano, met")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the mayor, mulled")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a couple matters over (what’s")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cheap date, they asked us; what’s")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("flat drink). Among Italian literati")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("we could recognize our counterparts:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the academic, the apologist,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the arrogant, the amorous,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the brazen and the glib—and there was one")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("administrator (the conservative), in suit")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("of regulation gray, who like a good tour guide")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("with measured pace and uninflected tone narrated")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("sights and histories the hired van hauled us past.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Of all, he was most politic and least poetic,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("so it seemed. Our last few days in Rome")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("(when all but three of the New World Bards had flown)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I found a book of poems this")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("unprepossessing one had written: it was there")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in the "), _c('em', [_vm._v("pensione")]), _vm._v(" room (a room he’d recommended)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("where it must have been abandoned by")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the German visitor (was there a bus of "), _c('em', [_vm._v("them")]), _vm._v("?)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to whom he had inscribed and dated it a month before.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I couldn’t read Italian, either, so I put the book")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("back into the wardrobe’s dark. We last Americans")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("were due to leave tomorrow. For our parting evening then")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("our host chose something in a family restaurant, and there")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("we sat and chatted, sat and chewed,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("till, sensible it was our last")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("big chance to be poetic, make")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("our mark, one of us asked")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("                                        “What’s poetry?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Is it the fruits and vegetables and")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("marketplace of Campo dei Fiori, or")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the statue there?” Because I was")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("the glib one, I identified the answer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("instantly, I didn’t have to think—“The truth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("is both, it’s both,” I blurted out. But that")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("was easy. That was easiest to say. What followed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("taught me something about difficulty,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("for our underestimated host spoke out,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("all of a sudden, with a rising passion, and he said:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The statue represents Giordano Bruno,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("brought to be burned in the public square")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("because of his offense against")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("authority, which is to say")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the Church. His crime was his belief")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the universe does not revolve around")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the human being: God is no")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("fixed point or central government, but rather is")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("poured in waves through all things. All things")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("move. “If God is not the soul itself, He is")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the soul of the soul of the world.” Such was")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("his heresy. The day they brought him")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("forth to die, they feared he might")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("incite the crowd (the man was famous")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("for his eloquence). And so his captors")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("placed upon his face")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("an iron mask, in which")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("he could not speak. That’s")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("how they burned him. That is how")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("he died: without a word, in front")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("of everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("               And poetry—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("                                    (we’d all")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("put down our forks by now, to listen to")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the man in gray; he went on")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("softly)—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("                         poetry is what")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("he thought, but did not say.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1800011b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 84
// module chunks = 0